export const related = [
  '/build-planner',
  '/abilities/ground-slam-vs-push',
  '/abilities',
];
export const quickAnswer =
  'Ignite supports weapon attacks with Burn. Inferno provides short-range fire. Choose weapon support or a dedicated fire action according to your playstyle.';
export const sourceIds = ['gamesradar-abilities', 'ps-ngplus'];
export const table = {
  headers: ['Ability', 'Fit', 'Trade-off'],
  rows: [
    [
      'Ignite',
      'Weapon-focused attacks',
      'Fits a plan built around weapon use.',
    ],
    [
      'Inferno',
      'Short-range fire actions',
      'Fits a plan that makes room for a separate fire ability.',
    ],
  ],
};

## Ignite vs Inferno Comparison

The Deserter Resonant offers this fire-focused choice. Decide whether you want fire to support your weapon routine or occupy its own place in that routine.

## How Ignite Plays

Ignite adds Burn to weapon attacks. Our weapon-focused recommendation is to start here if you want to preserve your existing combat rhythm.

## How Inferno Plays

Inferno is a short-range fire ability. Consider it when you enjoy dedicated ability use and regularly fight at the distance it requires.

## Which One Fits Your Build?

If weapon attacks are central to your plan, Ignite is a natural fit. If you want a separate short-range action, consider Inferno. These are editorial suggestions, not measured damage rankings.

## How to Change the Choice

Use the respec mural in The Gap with a Reset Item. Record the alternative in the planner before spending an in-game resource so you can compare the whole setup.
